const logo = () => {
  return {
    to: "/rus",
    image: {
      header: "1oCdDyHeiUZ65TU6RB78H4.svg",
      footer: "28wnZrx-S9SGkbz30xcUwg.svg"
    }
  };
};

const langs = () => {
  return [{ locale: "ru" }, { locale: "en" }];
};

const meta = banner => {
  return {
    logo: logo(),
    description: {
      to: "/rus",
      banner
    },
    API: process.env.VUE_APP_RU,
    langs: langs(),
    mask: "+# (###) ### - ## - ##"
  };
};

export default {
  path: "/rus",
  children: [
    {
      path: "/rus/post=:post",
      name: "helpcenter.project",
      meta: meta("PostBanner")
    }
  ],
  name: "helpcenter.project",
  meta: meta("ProjectBanner"),
  component: () => import("@/views/Project.vue")
};
